import React, { useState } from 'react';
import { Search, Loader } from 'lucide-react';
import styles from './SearchBar.module.css';

const SearchBar = ({ onSearch }) => {
    const [searchQuery, setSearchQuery] = useState('');
    const [isSearching, setIsSearching] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!searchQuery.trim()) return;

        setIsSearching(true);
        try {
            await onSearch(searchQuery);
        } finally {
            setIsSearching(false);
        }
    };

    const handleChange = (e) => {
        setSearchQuery(e.target.value);
    };

    return (
        <div className={styles.searchBarContainer}>
            <form onSubmit={handleSubmit} className={styles.searchForm}>
                <div className={styles.inputWrapper}>
                    <input
                        type="text"
                        value={searchQuery}
                        onChange={handleChange}
                        placeholder="Search presentations by title, or content..."
                        className={styles.searchInput}
                        aria-label="Search presentations"
                        disabled={isSearching}
                    />
                    <button
                        type="submit"
                        className={styles.searchButton}
                        aria-label="Search"
                        disabled={isSearching}
                    >
                        {isSearching ? (
                            <Loader className={styles.loadingIcon} size={20} />
                        ) : (
                            <Search size={20} />
                        )}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default SearchBar;